import Component from './setting_user_two_factor.vue'
export default Component
